export default __webpack_public_path__ + "static/img-triple-crown-point-first-20bcfe094bd6a7dbfe50a8ddd07a0b59.png";